import React from 'react'
import { Button, Modal } from "react-bootstrap";
import SubmitButton from "./SubmitButton";

export default function ConfirmModal({ show, close, primaryText, secondaryText, handleFunction, submitButtonText = 'Confirmar', submitingButtonText = 'Confirmando...', closeOnError = false }: any) {
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleClick = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      await handleFunction();
      // close modal after successful action
      close();
    } catch (e) {
      // log and optionally close on error
      console.error(e);
      if (closeOnError) close();
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <Modal show={show} onHide={close}>
      <Modal.Body>
        <h2>{primaryText}</h2>
        <p>{secondaryText}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => close()}>
          Cancelar
        </Button>
        <SubmitButton isSubmitting={isSubmitting} onClick={handleClick} submittingText={submitingButtonText}>
          {submitButtonText}
        </SubmitButton>
      </Modal.Footer>
    </Modal>
  )
}